import styled from 'styled-components';
import { showSnackbar } from 'components/shared/index';
import * as React from 'react';
import { useState } from 'react';
import { FormFieldsWrapper } from 'components/shared/AdminSettings/FormFieldsWrapper';
import { LoadingButton } from '@mui/lab';
import { getURLForFileUpload } from 'RestAPIs/admin';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Icon } from '@sdb/planning-ui';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

const axiosInstanceForUpload = axios.create({
  timeout: 600000
});

export const UploadFile = () => {
  const { t } = useTranslation('common', { keyPrefix: 'uploadFile' });
  const [isUploading, setIsUploading] = useState(false);
  const onChange = async (ev: React.ChangeEvent<HTMLInputElement>) => {
    const file: File | null = ev.target.files && ev.target?.files[0];
    if (file) {
      try {
        setIsUploading(true);
        const { data } = await getURLForFileUpload(file.name);
        const { uploadUrl } = data;
        await axiosInstanceForUpload.put(uploadUrl);
        showSnackbar({
          severity: 'success',
          message: t('s3uploadSuccess', { name: file.name })
        });
      } catch {
        showSnackbar({
          severity: 'error',
          message: t('s3uploadFailure', { name: file.name })
        });
      } finally {
        setIsUploading(false);
      }
    }
  };

  return (
    <FormFieldsWrapper>
      <LoadingButton
        loading={isUploading}
        variant="contained"
        component="label"
        color="primary"
        startIcon={<Icon type="upload" />}
      >
        {t('uploadFile')}
        <VisuallyHiddenInput type="file" onChange={onChange} />
      </LoadingButton>
    </FormFieldsWrapper>
  );
};
